import { Stack, Typography, FormGroup, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import { ScheduleWeek, ScheduleWeekMode } from "../../../../../types/actionModule/schedulingStrategy/schedulingStrategyType";
import { ScheduleDaysDefinitionProps, ScheduleDaysDefinitionEditor } from "./ScheduleDaysDefinitionEditor";
import { useTranslation } from "react-i18next";

export interface ScheduleWeeksDefinitionEditorProps extends ScheduleDaysDefinitionProps {
    weekModel: ScheduleWeek;
    onUpdateWeekModel: (value: ScheduleWeek) => void;
}

export function ScheduleWeeksDefinitionEditor(props: ScheduleWeeksDefinitionEditorProps) {
    const { t } = useTranslation();

    return <Stack sx={{pt: 4}}>
        <Typography variant="subtitle2">{t("actionModules.schedulingStrategy.scheduleDefinition.weeks.title")}</Typography>
        <Typography variant="caption">{t("actionModules.schedulingStrategy.scheduleDefinition.weeks.description")}</Typography>
        <FormGroup sx={{ flexDirection: "row", gap: 2, pt: 1 }}>
            <FormControl sx={{ minWidth: 250, flex: 1 }}>
                <InputLabel>{t("actionModules.schedulingStrategy.scheduleDefinition.weeks.scheduleMode.name")}</InputLabel>
                <Select
                    value={props.weekModel.mode}
                    size="small"
                    fullWidth
                    label={t("actionModules.schedulingStrategy.scheduleDefinition.weeks.scheduleMode.name")}
                    onChange={(e) => {
                        props.onUpdateWeekModel({
                            ...props.weekModel,
                            mode: e.target.value as ScheduleWeekMode
                        })
                    }}
                >
                    <MenuItem value={ScheduleWeekMode.None}>{t("actionModules.schedulingStrategy.scheduleDefinition.weeks.scheduleMode.none")}</MenuItem>
                    <MenuItem value={ScheduleWeekMode.Repeat}>{t("actionModules.schedulingStrategy.scheduleDefinition.weeks.scheduleMode.repeat")}</MenuItem>
                    <MenuItem value={ScheduleWeekMode.Skip}>{t("actionModules.schedulingStrategy.scheduleDefinition.weeks.scheduleMode.skip")}</MenuItem>
                </Select>
            </FormControl>
            {
                props.weekModel.mode === ScheduleWeekMode.Skip &&
                <TextField
                    value={props.weekModel.value}
                    type="number"
                    onChange={(e) => {
                        props.onUpdateWeekModel({
                            ...props.weekModel,
                            value: Number(e.target.value)
                        })
                    }}
                    size="small"
                    sx={{ minWidth: 100, flex: 1 }}
                    label={t("actionModules.schedulingStrategy.scheduleDefinition.weeks.scheduleMode.value")} />
            }
        </FormGroup>
        <ScheduleDaysDefinitionEditor
            dayModel={props.dayModel}
            onUpdateDayModel={props.onUpdateDayModel}
        />
    </Stack>
}
